<div *ngIf="isLoggedIn; else outletLogin">
  <div class="po-wrapper">
    <po-toolbar
    [p-title]="appTitle"
    [p-profile]="profile"
    [p-profile-actions]="profileActions"
    >
    </po-toolbar>

    <po-menu
    [p-menus]="menu"
    [p-filter]="false"
    [p-logo]="logo"
    [p-collapsed]="false"
    >
    </po-menu>
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #outletLogin>
  <router-outlet></router-outlet>
</ng-template>